export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export type Theme = (typeof THEME)[keyof typeof THEME];

export const THEME_PREFERENCE = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
} as const;

export type ThemePreference = (typeof THEME_PREFERENCE)[keyof typeof THEME_PREFERENCE];

export interface ThemePreferenceOption {
  value: ThemePreference;
  label: string;
  icon: string;
}

export const THEME_PREFERENCE_OPTIONS: ThemePreferenceOption[] = [
  { value: THEME_PREFERENCE.LIGHT, label: 'Claro', icon: 'light_mode' },
  { value: THEME_PREFERENCE.DARK, label: 'Oscuro', icon: 'dark_mode' },
  { value: THEME_PREFERENCE.SYSTEM, label: 'Según el sistema', icon: 'contrast' },
];

export const THEME_STORAGE_KEY = 'kore-ship-theme';

export const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)';
